import { render } from "./Link.vue?vue&type=template&id=5a381a57"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"

import "./Link.vue?vue&type=style&index=0&id=5a381a57&lang=scss"
script.render = render

export default script